// The overview tiles (also the menu's counters).
import { useQuery } from '@tanstack/react-query'
import { useApi } from '@/api/ApiProvider'

const keys = { overview: ['overview'] as const }

export function useOverview() {
  const api = useApi()
  return useQuery({ queryKey: keys.overview, queryFn: () => api.getOverview() })
}
